export default "__VITE_ASSET__5tdgSt9c__"